import { useCallback, useContext, useEffect } from "react";
import { CoreContext } from "context/CoreContext";
import { static_translation as chineseTranslation } from 'utils/i18n/chinese'
import { static_translation as englishTranslation } from 'utils/i18n/english'
import { static_translation as germanTranslation } from 'utils/i18n/german'
import { static_translation as hindiTranslation } from 'utils/i18n/hindi'
import { static_translation as japaneseTranslation } from 'utils/i18n/japanese'
import { static_translation as portugueseTranslation } from 'utils/i18n/portuguese'
import { static_translation as spanishTranslation } from 'utils/i18n/spanish'

const translationsByLanguage = {
    Chinese: chineseTranslation,
    English: englishTranslation,
    German: germanTranslation,
    Hindi: hindiTranslation,
    Japanese: japaneseTranslation,
    Portuguese: portugueseTranslation,
    Spanish: spanishTranslation,
}

export default function useI18n(){
    
    const { language, setLanguage, translation, setTranslation } = useContext(CoreContext)
    
    const t = useCallback(ref => translation?.translations?.[ref] || ref, [translation]);

    const loadTranslation = useCallback(async () => {
        const selectedTranslation = translationsByLanguage[language] || englishTranslation
        const next_translation = {
            language: language,
            translations:{ ...englishTranslation, ...selectedTranslation }
        }
        setTranslation(next_translation)
    }, [language, setTranslation])

    useEffect(() => { 
        loadTranslation()
    }, [loadTranslation])

    return {
        t,
        language,
        translation,
        setLanguage
    }
}
